const e=10,g="q",n=3,o="querySuggestionsPlugin";export{e as ALGOLIA_SUGGESTIONS_RESULTS_LIMIT,n as DEFAULT_MIN_REQUESTED_INPUT_LENGTH,g as DEFAULT_SEARCH_QUERY_URL_PARAM_KEY,o as QUERY_SUGGESTIONS_PLUGIN_SOURCE_ID};
